<template>
  <v-dialog v-model="dialog" max-width="400px">
    <v-card>
      <v-card-title
        primary-title
        style="background-color: black; text-align: left"
        class="pa-6"
        color="white"
      >
        <span style="font-family: Inter; color: white" class="text-h5">
          <v-icon color="white" style="margin-top: -3px">mdi-cog</v-icon>
          Edit Setting
        </span>
      </v-card-title>
      <v-col class="pa-6">
        <v-form ref="form" v-model="valid" @submit.prevent="save">
          <v-card-text class="pa-0 mb-2" color="black">
            <span style="font-family: Inter; font-weight: 600">
              {{ setting.key }}
            </span>
          </v-card-text>
          <v-text-field
            v-model="editedSetting.value"
            outlined
            dense
            color="black"
          ></v-text-field>
        </v-form>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn
            large
            depressed
            text
            class="rounded-md no-active-btn"
            @click="close"
          >
            <span
              style="
                font-family: Inter;
                text-transform: none;
                font-weight: 600;
                margin-top: -3px;
              "
              >Cancel</span
            >
          </v-btn>
          <v-btn
            depressed
            large
            color="black"
            class="rounded-md ml-4 white--text pl-4 pr-3"
            :disabled="!valid"
            @click="save"
          >
            <span
              style="
                font-family: Inter;
                text-transform: none;
                font-weight: 600;
                margin-top: -3px;
              "
              >Save</span
            >
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-card-actions>
      </v-col>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    setting: {
      key: String,
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: true,
      valid: true,
      editedSetting: { ...this.setting },
      arrayValue:
        this.setting.type === 'ARRAY'
          ? this.setting.array_value.join(', ')
          : '',
      rules: {
        required: (v) => !!v || 'This field is required',
      },
    };
  },
  methods: {
    close() {
      this.$emit('close');
    },
    save() {
      if (this.$refs.form.validate()) {
        const updatedSetting = { ...this.editedSetting };
        if (updatedSetting.type === 'ARRAY') {
          updatedSetting.array_value = this.arrayValue
            .split(',')
            .map((item) => item.trim());
        }
        this.$emit('save', updatedSetting);
      }
    },
  },
};
</script>
